import React from 'react';
import LoadingDataUi from '@app/components/loading';
import moment from 'moment';
import { TableBox } from '../style';
import { CgTrashEmpty } from 'react-icons/cg';
import { FiEdit3 } from 'react-icons/fi';

const Table = ({ loading, categories, handleShow, handleDelete }) => {
  return (
    <div>
      {loading ? (
        <LoadingDataUi />
      ) : (
        <TableBox>
          <table>
            <thead className="table_head">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody className="table_body">
              {categories?.map((data) => (
                <tr key={data._id}>
                  <td>{data.name}</td>
                  <td>{data.description}</td>
                  <td>{moment(data.created_at).format('LL')}</td>
                  <td>
                    <div className="flex items-center gap-10">
                      <div
                        onClick={() => handleShow(data)}
                        className="cursor-pointer"
                      >
                        <FiEdit3
                          className="text-[20px] text-[#549a9a]"
                          color="#549a9a"
                        />{' '}
                      </div>
                      <div
                        onClick={() => handleDelete(data._id)}
                        className="cursor-pointer"
                      >
                        <CgTrashEmpty className="text-red-500 text-[20px]" />{' '}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TableBox>
      )}
    </div>
  );
};

export default Table;
